import { useEffect, useState } from 'react';
import api from '../api';
import './home.css';

export default function AdminLiveSettings() {
  const [s, setS] = useState({ liveCheckEnabled:false, twitchEnabled:true, youtubeEnabled:true, tiktokEnabled:false, ttlMs:30000, minIntervalMs:5000, twitchContentEnabled:true, youtubeContentEnabled:true, tiktokContentEnabled:true });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState('');
  // Secret handling
  const [twitchClientId, setTwitchClientId] = useState('');
  const [twitchClientSecret, setTwitchClientSecret] = useState('');
  const [youtubeApiKey, setYoutubeApiKey] = useState('');
  const [googleClientId, setGoogleClientId] = useState('');
  const [googleClientSecret, setGoogleClientSecret] = useState('');
  const [tiktokClientKey, setTikTokClientKey] = useState('');
  const [tiktokClientSecret, setTikTokClientSecret] = useState('');
  const [steamGridDbApiKey, setSteamGridDbApiKey] = useState('');
  const [externalPointsApiKey, setExternalPointsApiKey] = useState('');
  const [maskInfo, setMaskInfo] = useState({ twitchClientIdMasked:'', twitchClientSecretMasked:'', youtubeApiKeyMasked:'', googleClientIdMasked:'', googleClientSecretMasked:'', tiktokClientKeyMasked:'', tiktokClientSecretMasked:'', steamGridDbApiKeyMasked:'', externalPointsApiKeyMasked:'' });
  const [ytMeta, setYtMeta] = useState(null);
  const [ttMeta, setTtMeta] = useState(null);
  const [metaAppId, setMetaAppId] = useState('');
  const [metaAppSecret, setMetaAppSecret] = useState('');
  const [igMeta, setIgMeta] = useState(null);
  // Live-Status Schnelltest state
  const [testPlatform, setTestPlatform] = useState('twitch');
  const [testValues, setTestValues] = useState({ twitchChannel:'', youtubeVideoId:'', youtubeChannelId:'', tiktokUsername:'' });
  const [testLoading, setTestLoading] = useState(false);
  const [testError, setTestError] = useState('');
  const [testResult, setTestResult] = useState(null); // { live: boolean }
  const [lastCheckedAt, setLastCheckedAt] = useState(null);

  useEffect(() => {
    api.get('/admin/live-settings').then(res => {
      const data = res.data || {};
      // Settings without secrets; we get masked strings separately
  const { twitchClientIdMasked, twitchClientSecretMasked, youtubeApiKeyMasked, googleClientIdMasked, googleClientSecretMasked, tiktokClientKeyMasked, tiktokClientSecretMasked, metaAppIdMasked, metaAppSecretMasked, steamGridDbApiKeyMasked, externalPointsApiKeyMasked, ...rest } = data;
      setS(rest);
      setMaskInfo({
        twitchClientIdMasked: twitchClientIdMasked || '',
        twitchClientSecretMasked: twitchClientSecretMasked || '',
        youtubeApiKeyMasked: youtubeApiKeyMasked || '',
        googleClientIdMasked: googleClientIdMasked || '',
        googleClientSecretMasked: googleClientSecretMasked || '',
        tiktokClientKeyMasked: tiktokClientKeyMasked || '',
        tiktokClientSecretMasked: tiktokClientSecretMasked || '',
        metaAppIdMasked: metaAppIdMasked || '',
        metaAppSecretMasked: metaAppSecretMasked || '',
        steamGridDbApiKeyMasked: steamGridDbApiKeyMasked || '',
        externalPointsApiKeyMasked: externalPointsApiKeyMasked || ''
      });
      setLoading(false);
    }).catch(e => {
      setError(e?.response?.data?.error || e.message);
      setLoading(false);
    });
  }, []);

  async function save() {
    setSaving(true); setError(''); setOk('');
    try {
      const payload = {
        ...s,
        // Only send secrets if provided; empty string means clear
        ...(twitchClientId !== '' ? { twitchClientId } : {}),
        ...(twitchClientSecret !== '' ? { twitchClientSecret } : {}),
        ...(youtubeApiKey !== '' ? { youtubeApiKey } : {}),
        ...(googleClientId !== '' ? { googleClientId } : {}),
        ...(googleClientSecret !== '' ? { googleClientSecret } : {}),
        ...(tiktokClientKey !== '' ? { tiktokClientKey } : {}),
        ...(tiktokClientSecret !== '' ? { tiktokClientSecret } : {}),
        ...(metaAppId !== '' ? { metaAppId } : {}),
        ...(metaAppSecret !== '' ? { metaAppSecret } : {}),
        ...(steamGridDbApiKey !== '' ? { steamGridDbApiKey } : {}),
        ...(externalPointsApiKey !== '' ? { externalPointsApiKey } : {}),
      };
      const { data } = await api.put('/admin/live-settings', payload);
  const { twitchClientIdMasked, twitchClientSecretMasked, youtubeApiKeyMasked, googleClientIdMasked, googleClientSecretMasked, tiktokClientKeyMasked, tiktokClientSecretMasked, metaAppIdMasked, metaAppSecretMasked, steamGridDbApiKeyMasked, externalPointsApiKeyMasked, ...rest } = data || {};
      setS(rest);
      setMaskInfo({
        twitchClientIdMasked: twitchClientIdMasked || '',
        twitchClientSecretMasked: twitchClientSecretMasked || '',
        youtubeApiKeyMasked: youtubeApiKeyMasked || '',
        googleClientIdMasked: googleClientIdMasked || '',
        googleClientSecretMasked: googleClientSecretMasked || '',
        tiktokClientKeyMasked: tiktokClientKeyMasked || '',
        tiktokClientSecretMasked: tiktokClientSecretMasked || '',
        metaAppIdMasked: metaAppIdMasked || '',
        metaAppSecretMasked: metaAppSecretMasked || '',
        steamGridDbApiKeyMasked: steamGridDbApiKeyMasked || '',
        externalPointsApiKeyMasked: externalPointsApiKeyMasked || ''
      });
      // Clear local input fields after save to avoid displaying secrets
      setTwitchClientId('');
      setTwitchClientSecret('');
      setYoutubeApiKey('');
      setGoogleClientId('');
      setGoogleClientSecret('');
      setTikTokClientKey('');
      setTikTokClientSecret('');
      setMetaAppId('');
      setMetaAppSecret('');
  setSteamGridDbApiKey('');
  setExternalPointsApiKey('');
      setOk('Gespeichert');
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally { setSaving(false); }
  }

  if (loading) return <div style={{padding:24}}>Lade ...</div>;

  return (
    <div className="home-page">
      {/* Outer full-bleed container */}
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Live-Status Prüfung</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Konfiguriere die Live-Überprüfung und API-Schlüssel.</p>
        <p className="hero-desc" style={{ marginTop:-12, marginBottom: 24, opacity:.85, textAlign:'center', maxWidth:760, marginLeft:'auto', marginRight:'auto' }}>Zusätzlich pro Plattform: getrennte Schalter für das Abrufen von Inhalten (VoDs/Clips/Videos/Shorts) unabhängig von der Live-Prüfung.</p>
      </section>
      {/* Centered content container */}
      <section style={{ width:'100%', maxWidth: 800, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        {error && <div style={{color:'tomato',marginBottom:12}}>{error}</div>}
        {ok && <div style={{color:'#32CD89',marginBottom:12}}>{ok}</div>}
        {/* Schnelltest: Live-Status */}
        <div style={{ border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:16, marginBottom:16, background:'rgba(255,255,255,0.03)' }}>
          <h3 style={{ marginTop:0, marginBottom:8 }}>Schnelltest: Live-Status</h3>
          <div style={{display:'grid', gap:12}}>
            <div>
              <div style={{ marginBottom:6 }}>Plattform</div>
              <select value={testPlatform} onChange={e=>{ setTestPlatform(e.target.value); setTestError(''); setTestResult(null); }} className="hero-btn-secondary">
                <option value="twitch">Twitch</option>
                <option value="youtube">YouTube</option>
                <option value="tiktok">TikTok</option>
              </select>
            </div>
            {testPlatform === 'twitch' && (
              <div>
                <div style={{ marginBottom:6 }}>Twitch Kanal (Login-Name)</div>
                <input type="text" value={testValues.twitchChannel} onChange={e=>setTestValues(v=>({...v, twitchChannel:e.target.value}))} placeholder="z. B. somechannel" className="hero-btn-secondary" />
              </div>
            )}
            {testPlatform === 'youtube' && (
              <div style={{display:'grid', gap:8}}>
                <div>
                  <div style={{ marginBottom:6 }}>YouTube Video ID (optional)</div>
                  <input type="text" value={testValues.youtubeVideoId} onChange={e=>setTestValues(v=>({...v, youtubeVideoId:e.target.value}))} placeholder="z. B. dQw4w9WgXcQ" className="hero-btn-secondary" />
                </div>
                <div>
                  <div style={{ marginBottom:6 }}>YouTube Channel ID (falls keine Video ID)</div>
                  <input type="text" value={testValues.youtubeChannelId} onChange={e=>setTestValues(v=>({...v, youtubeChannelId:e.target.value}))} placeholder="z. B. UC-XXXXXXXX" className="hero-btn-secondary" />
                </div>
                <div style={{ fontSize:12, opacity:.75 }}>Gib entweder eine Video ID oder eine Channel ID an. Bei Video ID hat diese Vorrang.</div>
              </div>
            )}
            {testPlatform === 'tiktok' && (
              <div>
                <div style={{ marginBottom:6 }}>TikTok Benutzername</div>
                <input type="text" value={testValues.tiktokUsername} onChange={e=>setTestValues(v=>({...v, tiktokUsername:e.target.value}))} placeholder="z. B. someuser" className="hero-btn-secondary" />
              </div>
            )}
            <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
              <button className="hero-btn-secondary" onClick={async()=>{
                setTestError(''); setTestResult(null); setLastCheckedAt(null);
                // Basic validation per platform
                if (testPlatform === 'twitch' && !testValues.twitchChannel.trim()) { setTestError('Bitte Twitch Kanal eingeben'); return; }
                if (testPlatform === 'youtube' && !testValues.youtubeVideoId.trim() && !testValues.youtubeChannelId.trim()) { setTestError('Bitte Video ID oder Channel ID angeben'); return; }
                if (testPlatform === 'tiktok' && !testValues.tiktokUsername.trim()) { setTestError('Bitte TikTok Benutzername eingeben'); return; }
                setTestLoading(true);
                try {
                  const payload = { platform: testPlatform };
                  if (testPlatform === 'twitch') payload.twitchChannel = testValues.twitchChannel.trim();
                  if (testPlatform === 'youtube') { if (testValues.youtubeVideoId.trim()) payload.youtubeVideoId = testValues.youtubeVideoId.trim(); else payload.youtubeChannelId = testValues.youtubeChannelId.trim(); }
                  if (testPlatform === 'tiktok') payload.tiktokUsername = testValues.tiktokUsername.trim();
                  const { data } = await api.post('/live/check', payload);
                  setTestResult(data || null);
                  setLastCheckedAt(new Date());
                } catch (e) {
                  const m = e?.response?.data?.error || e.message;
                  setTestError(m);
                  setLastCheckedAt(new Date());
                } finally { setTestLoading(false); }
              }} disabled={testLoading}>{testLoading ? 'Prüfe…' : 'Jetzt prüfen'}</button>
              {lastCheckedAt && (
                <div style={{ fontSize:13, opacity:.85 }}>Zuletzt geprüft: {lastCheckedAt.toLocaleString()}</div>
              )}
            </div>
            {testError && <div style={{color:'tomato'}}>{testError}</div>}
            {testResult && (
              <div style={{ marginTop:6 }}>
                Status: {testResult.live ? <span style={{color:'#32CD89'}}>LIVE</span> : <span style={{opacity:.85}}>offline</span>}
              </div>
            )}
            <div style={{ fontSize:12, opacity:.7 }}>
              Rate-Limit: abhängig von „Min. Intervall (ms)“. Bei deaktivierter Live-Prüfung erscheint 503 (disabled).
            </div>
          </div>
        </div>
        <div style={{display:'grid', gap:16}}>
          <label style={{display:'flex',alignItems:'center',gap:8}}>
            <input type="checkbox" checked={!!s.liveCheckEnabled} onChange={e=>setS(p=>({...p, liveCheckEnabled:e.target.checked}))} />
            Live-Prüfung aktivieren
          </label>
          <label style={{display:'flex',alignItems:'center',gap:8}}>
            <input type="checkbox" checked={!!s.twitchEnabled} onChange={e=>setS(p=>({...p, twitchEnabled:e.target.checked}))} />
            Twitch prüfen
          </label>
          <label style={{display:'flex',alignItems:'center',gap:8, marginLeft:24}}>
            <input type="checkbox" checked={!!s.twitchContentEnabled} onChange={e=>setS(p=>({...p, twitchContentEnabled:e.target.checked}))} />
            Twitch Inhalte abrufen
          </label>
          <label style={{display:'flex',alignItems:'center',gap:8}}>
            <input type="checkbox" checked={!!s.youtubeEnabled} onChange={e=>setS(p=>({...p, youtubeEnabled:e.target.checked}))} />
            YouTube prüfen
          </label>
          <label style={{display:'flex',alignItems:'center',gap:8, marginLeft:24}}>
            <input type="checkbox" checked={!!s.youtubeContentEnabled} onChange={e=>setS(p=>({...p, youtubeContentEnabled:e.target.checked}))} />
            YouTube Inhalte abrufen
          </label>
          <label style={{display:'flex',alignItems:'center',gap:8}}>
            <input type="checkbox" checked={!!s.tiktokEnabled} onChange={e=>setS(p=>({...p, tiktokEnabled:e.target.checked}))} />
            TikTok prüfen (Experimentell)
          </label>
          <label style={{display:'flex',alignItems:'center',gap:8, marginLeft:24}}>
            <input type="checkbox" checked={!!s.tiktokContentEnabled} onChange={e=>setS(p=>({...p, tiktokContentEnabled:e.target.checked}))} />
            TikTok Inhalte abrufen
          </label>
          {/* Instagram temporarily disabled: toggle removed */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr', gap:12}}>
            <div>
              <div>Cache-TTL (ms)</div>
              <input type="number" value={s.ttlMs} onChange={e=>setS(p=>({...p, ttlMs: parseInt(e.target.value||'0',10)}))} className="hero-btn-secondary" />
            </div>
            <div>
              <div>Min. Intervall (ms)</div>
              <input type="number" value={s.minIntervalMs} onChange={e=>setS(p=>({...p, minIntervalMs: parseInt(e.target.value||'0',10)}))} className="hero-btn-secondary" />
            </div>
          </div>

          <div style={{ borderTop:'1px solid rgba(255,255,255,0.15)', marginTop:12, paddingTop:16 }}>
            <h3 style={{ margin:'8px 0 8px 0' }}>API-Schlüssel</h3>
            <div style={{display:'grid', gap:12}}>
              <div>
                <div style={{ marginBottom:6 }}>Twitch Client ID</div>
                <input type="text" value={twitchClientId} onChange={e=>setTwitchClientId(e.target.value)} placeholder={maskInfo.twitchClientIdMasked ? `Gesetzt: ${maskInfo.twitchClientIdMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                <div style={{ fontSize:12, opacity:.75, marginTop:4 }}>Leer lassen, um bestehenden Wert beizubehalten. Mit leerem String speichern, um zu löschen.</div>
              </div>
              <div>
                <div style={{ marginBottom:6 }}>Twitch Client Secret</div>
                <input type="password" value={twitchClientSecret} onChange={e=>setTwitchClientSecret(e.target.value)} placeholder={maskInfo.twitchClientSecretMasked ? `Gesetzt: ${maskInfo.twitchClientSecretMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
              </div>
              <div>
                <div style={{ marginBottom:6 }}>YouTube API Key</div>
                <input type="password" value={youtubeApiKey} onChange={e=>setYoutubeApiKey(e.target.value)} placeholder={maskInfo.youtubeApiKeyMasked ? `Gesetzt: ${maskInfo.youtubeApiKeyMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
              </div>
              <div>
                <div style={{ marginBottom:6 }}>SteamGridDB API Key</div>
                <input type="password" value={steamGridDbApiKey} onChange={e=>setSteamGridDbApiKey(e.target.value)} placeholder={maskInfo.steamGridDbApiKeyMasked ? `Gesetzt: ${maskInfo.steamGridDbApiKeyMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                <div style={{ fontSize:12, opacity:.75, marginTop:4 }}>Wird für hochkantige Spiel‑Cover (600×900) genutzt. Leer lassen, um zu behalten. Leer speichern zum Löschen.</div>
              </div>
              <div>
                <div style={{ marginBottom:6 }}>External Points API Key</div>
                <input type="password" value={externalPointsApiKey} onChange={e=>setExternalPointsApiKey(e.target.value)} placeholder={maskInfo.externalPointsApiKeyMasked ? `Gesetzt: ${maskInfo.externalPointsApiKeyMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                <div style={{ fontSize:12, opacity:.75, marginTop:4 }}>Wird für die externe Punkte‑Gutschrift API genutzt. Header: <code>x-api-key</code> oder Query <code>?key=…</code>. Leer lassen, um zu behalten. Leer speichern zum Löschen.</div>
              </div>
              <div style={{ borderTop:'1px dashed rgba(255,255,255,0.15)', paddingTop:12, marginTop:8 }}>
                <div style={{ marginBottom:6, fontWeight:700 }}>TikTok OAuth</div>
                <div style={{display:'grid', gap:12}}>
                  <div>
                    <div style={{ marginBottom:6 }}>TikTok Client Key</div>
                    <input type="text" value={tiktokClientKey} onChange={e=>setTikTokClientKey(e.target.value)} placeholder={maskInfo.tiktokClientKeyMasked ? `Gesetzt: ${maskInfo.tiktokClientKeyMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                  </div>
                  <div>
                    <div style={{ marginBottom:6 }}>TikTok Client Secret</div>
                    <input type="password" value={tiktokClientSecret} onChange={e=>setTikTokClientSecret(e.target.value)} placeholder={maskInfo.tiktokClientSecretMasked ? `Gesetzt: ${maskInfo.tiktokClientSecretMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                  </div>
                  <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
                    <button className="hero-btn-secondary" onClick={async () => {
                      setError(''); setOk('');
                      try {
                        const { data } = await api.get('/integrations/tiktok/meta');
                        setTtMeta(data);
                        setOk('TikTok Meta geladen');
                      } catch (e) {
                        setError(e?.response?.data?.error || 'TikTok Meta konnte nicht geladen werden');
                      }
                    }}>Meta abrufen</button>
                    {ttMeta && (
                      <div style={{fontSize:13, opacity:.85}}>
                        Client Key gesetzt: <b>{ttMeta.clientKeySet ? 'Ja' : 'Nein'}</b> · Redirect URI: <code style={{background:'#111827', padding:'2px 6px', borderRadius:4}}>{ttMeta.redirectUri}</code>{' '}
                        · Scopes: {(ttMeta.scopes||[]).join(', ')}
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize:12, opacity:.75 }}>
                    Trage die Redirect‑URI in der TikTok Developer Console ein. Scopes: user.info.basic, user.info.profile, video.list.
                  </div>
                </div>
              </div>
              <div style={{ borderTop:'1px dashed rgba(255,255,255,0.15)', paddingTop:12, marginTop:8 }}>
                <div style={{ marginBottom:6, fontWeight:700 }}>YouTube OAuth (Google)</div>
                <div style={{display:'grid', gap:12}}>
                  <div>
                    <div style={{ marginBottom:6 }}>Google Client ID</div>
                    <input type="text" value={googleClientId} onChange={e=>setGoogleClientId(e.target.value)} placeholder={maskInfo.googleClientIdMasked ? `Gesetzt: ${maskInfo.googleClientIdMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                  </div>
                  <div>
                    <div style={{ marginBottom:6 }}>Google Client Secret</div>
                    <input type="password" value={googleClientSecret} onChange={e=>setGoogleClientSecret(e.target.value)} placeholder={maskInfo.googleClientSecretMasked ? `Gesetzt: ${maskInfo.googleClientSecretMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                  </div>
                  <div style={{ fontSize:12, opacity:.75 }}>
                    Hinweis: Diese Werte gelten global für die Anwendung und werden nur von Admins gesetzt. Nutzer verbinden ihren Kanal per OAuth, die App-Credentials bleiben gleich.
                  </div>
                </div>
              </div>
              <div style={{ borderTop:'1px dashed rgba(255,255,255,0.15)', paddingTop:12, marginTop:8 }}>
                <div style={{ marginBottom:6, fontWeight:700 }}>Instagram (Meta) OAuth</div>
                <div style={{display:'grid', gap:12}}>
                  <div>
                    <div style={{ marginBottom:6 }}>Meta App ID</div>
                    <input type="text" value={metaAppId} onChange={e=>setMetaAppId(e.target.value)} placeholder={maskInfo.metaAppIdMasked ? `Gesetzt: ${maskInfo.metaAppIdMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                  </div>
                  <div>
                    <div style={{ marginBottom:6 }}>Meta App Secret</div>
                    <input type="password" value={metaAppSecret} onChange={e=>setMetaAppSecret(e.target.value)} placeholder={maskInfo.metaAppSecretMasked ? `Gesetzt: ${maskInfo.metaAppSecretMasked}` : 'Nicht gesetzt'} className="hero-btn-secondary" />
                  </div>
                  <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
                    <button className="hero-btn-secondary" onClick={async()=>{
                      setError(''); setOk('');
                      try {
                        const { data } = await api.get('/integrations/instagram/meta');
                        setIgMeta(data);
                        setOk('Instagram Meta geladen');
                      } catch (e) {
                        setError(e?.response?.data?.error || 'Instagram Meta konnte nicht geladen werden');
                      }
                    }}>Meta abrufen</button>
                    {igMeta && (
                      <div style={{fontSize:13, opacity:.85}}>
                        App ID gesetzt: <b>{igMeta.appIdSet ? 'Ja' : 'Nein'}</b> · Redirect URI: <code style={{background:'#111827', padding:'2px 6px', borderRadius:4}}>{igMeta.redirectUri}</code>
                        {' '}· Scopes: {(igMeta.scopes||[]).join(', ')}
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize:12, opacity:.75 }}>
                    Trage die Redirect‑URI im Meta App‑Dashboard unter „Valid OAuth Redirect URIs“ ein. Benötigte Berechtigungen: instagram_basic, pages_show_list, pages_read_engagement, instagram_manage_insights.
                  </div>
                </div>
              </div>
              {/* Instagram secrets removed while feature is disabled */}
              <div style={{ fontSize:12, opacity:.75 }}>
                Hinweis: Werte werden serverseitig sicher gespeichert und nicht im Klartext zurückgegeben.
              </div>
            </div>
          </div>
          <div style={{ borderTop:'1px solid rgba(255,255,255,0.15)', marginTop:12, paddingTop:16 }}>
            <h3 style={{ margin:'8px 0 8px 0' }}>YouTube OAuth Prüfung</h3>
            <div style={{display:'flex', gap:8, alignItems:'center', flexWrap:'wrap'}}>
              <button className="hero-btn-secondary" onClick={async () => {
                setError(''); setOk('');
                try {
                  const { data } = await api.get('/integrations/youtube/meta');
                  setYtMeta(data);
                  setOk('Meta geladen');
                } catch (e) {
                  setError(e?.response?.data?.error || 'Meta konnte nicht geladen werden');
                }
              }}>Meta abrufen</button>
              {ytMeta && (
                <div style={{fontSize:13, opacity:.85}}>
                  Client ID gesetzt: <b>{ytMeta.clientIdSet ? 'Ja' : 'Nein'}</b> · Redirect URI: <code style={{background:'#111827', padding:'2px 6px', borderRadius:4}}>{ytMeta.redirectUri}</code>
                </div>
              )}
            </div>
            <div style={{ fontSize:12, opacity:.75, marginTop:8 }}>
              Trage die Redirect‑URI in der Google Cloud Console im OAuth‑Client ein. Scopes (Info): {`youtube.readonly`}, {`yt-analytics.readonly`}.
            </div>
          </div>
          <div>
            <button className="hero-btn-primary" onClick={save} disabled={saving}>{saving? 'Speichere...' : 'Speichern'}</button>
          </div>
          <div style={{opacity:.7, fontSize:13}}>
            Alternativ zu Umgebungsvariablen können die Schlüssel hier verwaltet werden. Umgebungsvariablen dienen als Fallback.
          </div>
        </div>
      </section>
    </div>
  );
}
